import type { KambiCashOutValue, KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { KambiReward, KambiRewardCount } from '@mobi/api-types/kambi/player/reward'
import { getFromKambiPlayerApi } from './utils/getFromKambiPlayerApi'

export const getKambiPendingBetHistory = async () => {
  try {
    return getKambiBetsHistory('PENDING', 100, 0)
  } catch {
    return null
  }
}

export const getKambiPendingBetCoupon = async (couponRef: number) => {
  try {
    const response = await getFromKambiPlayerApi<KambiHistoryCoupon[]>({
      urlPath: `coupon/history/${couponRef}`,
    })
    return response
  } catch {
    return null
  }
}

export const getKambiActiveSpecials = () =>
  getFromKambiPlayerApi<KambiRewardsResponse>({
    urlPath: `reward/status/ACTIVE?showCounts=true`,
  })

export const getKambiPendingBetsCashOutStatus = async () => {
  try {
    const response = await getFromKambiPlayerApi<KambiCashOutValue[]>({
      urlPath: `cashout.json?lang=en_AU&market=AU`,
    })
    return response
  } catch {
    return null
  }
}

export const getKambiBetsHistory = async (
  betStatus: KambiBetStatusQuery,
  rangeSize: number,
  rangeStart: number
) => {
  try {
    const response = await getFromKambiPlayerApi<KambiHistoryResponse | null>({
      urlPath: `coupon/history?range_size=${rangeSize}&range_start=${rangeStart}&status=${betStatus}`,
    })
    return response
  } catch {
    return null
  }
}

// =====
// Types
// =====

type KambiHistoryResponse = {
  historyCoupons: KambiHistoryCoupon[]
  range: {
    /** Offset from first. */
    start: number
    /** Number of objects in this range. */
    size: number
    /** true if more results are available. */
    more: boolean
  }
}

type KambiRewardsResponse = {
  rewards: KambiReward[]
  groupRewards: KambiReward[]
  pendingRewards: KambiReward[]
  implicitGroupRewards: KambiReward[]
  rewardCounts: KambiRewardCount
}

export type KambiBetStatusQuery = 'PENDING' | 'SETTLED' | 'LOST' | 'WON' | 'CASHED_OUT' | 'VOID'
